"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var GlobalUtils_js_1 = __importDefault(require("../../../../../../shared/util/GlobalUtils.js"));
var OrthographicEventDistribution_1 = require("./OrthographicEventDistribution");
var OrthographicLogic_1 = require("./OrthographicLogic");
var HooksAndNotifiers_1 = require("../../../../helpers/HooksAndNotifiers");
var OrthographicHooks_1 = require("./OrthographicHooks");
var OrthographicManager = /** @class */ (function () {
    // #endregion Properties (3)
    // #region Constructors (1)
    function OrthographicManager(_settings, _cameraControls, _triggerRender, _logWarning) {
        this._settings = _settings;
        this._cameraControls = _cameraControls;
        this._triggerRender = _triggerRender;
        this._logWarning = _logWarning;
        // #region Properties (3)
        this._globalUtils = GlobalUtils_js_1.default;
        this._cameraLogic = new OrthographicLogic_1.OrthographicLogic(this._settings, this._cameraControls);
        this._cameraEventDistribution = new OrthographicEventDistribution_1.OrthographicEventDistribution(this._settings, this._cameraControls, this._cameraLogic);
        this._cameraControls.registerCameraControls(this);
        HooksAndNotifiers_1.registerHooksAndNotifiers(this, this._settings, OrthographicHooks_1.OrthographicControlsHooks, OrthographicHooks_1.OrthographicControlsNotifiers);
    }
    // #endregion Constructors (1)
    // #region Public Methods (12)
    OrthographicManager.prototype.isWithinRestrictions = function (position, target) {
        return true;
    };
    OrthographicManager.prototype.onKeyDown = function (event) {
        this._cameraEventDistribution.onKeyDown(event);
    };
    OrthographicManager.prototype.onMouseDown = function (event) {
        this._cameraEventDistribution.onMouseDown(event);
    };
    OrthographicManager.prototype.onMouseMove = function (event) {
        this._cameraEventDistribution.onMouseMove(event);
    };
    OrthographicManager.prototype.onMouseUp = function (event) {
        this._cameraEventDistribution.onMouseUp(event);
    };
    OrthographicManager.prototype.onMouseWheel = function (event) {
        this._cameraEventDistribution.onMouseWheel(event);
    };
    OrthographicManager.prototype.onTouchEnd = function (event) {
        this._cameraEventDistribution.onTouchEnd(event);
    };
    OrthographicManager.prototype.onTouchMove = function (event) {
        this._cameraEventDistribution.onTouchMove(event);
    };
    OrthographicManager.prototype.onTouchStart = function (event) {
        this._cameraEventDistribution.onTouchStart(event);
    };
    OrthographicManager.prototype.reset = function () {
        this._cameraEventDistribution.reset();
        this._cameraLogic.reset();
    };
    OrthographicManager.prototype.restrict = function (position, target) {
        return { position: position, target: target };
    };
    OrthographicManager.prototype.update = function (time, manualInteraction) {
        this._cameraLogic.update(time, manualInteraction);
    };
    return OrthographicManager;
}());
exports.OrthographicManager = OrthographicManager;
;
